import { observer } from "mobx-react-lite"
import styles from "./../sharedStyles.module.scss"
import ExternalLinkOutline from "~icons/eva/external-link-outline"
import CruisenHelpCenterIcon from "../../../../../assets/cruisenHelpCenterIcon.png"
import { DefaultSpinner } from "../../../../loaders/DefaultSpinner"

export const SlackInformation = observer(
  ({ isLoading, navigateToDashboard }: { isLoading: boolean; navigateToDashboard: () => void }) => {
    return (
      <div className={styles.form}>
        <div className={styles.descriptionContainer}>
          <div className={styles.slackContainer}>
            <p className={styles.slackSubtitle}>Did you know...</p>
            <p className={styles.slackDescription}>
              Cruisen has a comprehensive help center where you can find guides, best practices, and
              answers to commonly asked questions about using the platform.
            </p>
            <div className={styles.slackCommunity}>
              <div className={styles.cruisenCommunityIcon}>
                <img
                  className={styles.cruisenCommunityIconImage}
                  src={CruisenHelpCenterIcon}
                  alt="Cruisen Community Icon"
                />
              </div>
              <a
                href="https://help.cruisen.com"
                className={styles.slackButton}
                target="_blank"
                rel="noreferrer"
              >
                <ExternalLinkOutline className={styles.slackButtonIcon} />
                Visit the Help Center
              </a>
            </div>
          </div>
        </div>
        <button
          type="button"
          className={styles.button}
          disabled={isLoading}
          onClick={navigateToDashboard}
          data-testid="continue-cruisen"
        >
          {isLoading && (
            <DefaultSpinner
              size="sm"
              style={
                {
                  marginRight: "10px",
                } as React.CSSProperties
              }
            />
          )}
          Continue to Cruisen
        </button>
      </div>
    )
  },
)
